var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-mx-status-label"},[_c('asc-label',{attrs:{"size":"sm","value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }